module.exports = __webpack_public_path__ + "static/media/dtrans.8bda5df1.pdf";